export default function AttachPreparationItemReportDirective() {
  return {
    template: require('./attach-preparation-item-report.html'),
    scope: {
      preparationItemId: '=',
      serviceId: '=',
      reportId: '=',
      report: '=',
    },
    controller: 'AttachPreparationItemReportController',
    controllerAs: 'attachPreparationItemReportVM',
    bindToController: true,
    replace: true
  };
}
